import theme from '@styles/theme';
export default {
  sliderContainer: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: ['space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: 'no-wrap',
    overflow: 'hidden',
    '.swiper.swiper-horizontal>.swiper-scrollbar': {
      margin: '30px auto 32px',
      position: 'static',
      height: '2px',
      background: '#cccccc',
      borderRadius: '1px',
      width: ['calc(100% - 80px)', 'calc(100% - 80px)', 'calc(100% - 128px)'],
      display: ['block', 'block', 'block', 'block', 'none'],
      order: 1
    },
    '.swiper.swiper-horizontal>.swiper-scrollbar .swiper-scrollbar-drag': {
      backgroundColor: theme.rawColors.darkGrey700,
      cursor: 'pointer'
    },
    '.swiper': {
      display: 'flex',
      flexDirection: 'column',
      order: 0,
      '.swiper-slide': {
        width: 'auto',
        transform: ['translateX(0)', 'translateX(0)', 'translateX(0)', 'translateX(0)', 'translateX(40px)'],
        '&:last-of-type': {
          mr: [0, 0, 0, 0, 80]
        }
      }
    }
  },
  slideContainer: {
    '&:hover .modal_product': {
      transform: 'translate(0)',
      span: {
        opacity: 1
      }
    }
  },
  sliderImgContainer: (haveProducts: boolean) => ({
    position: 'relative',
    height: 'auto',
    margin: '0',
    flexShrink: 0,
    cursor: ['default', 'default', haveProducts ? 'pointer' : 'default']
  }),
  progressBar: {
    width: 'auto',
    m: ['0 24px', '0 40px', '0 64px', '0 64px', 0],
    display: ['flex', 'flex', 'flex', 'flex', 'none']
  },
  scrollbar: (active: boolean) => ({
    '.swiper-scrollbar': {
      display: active ? 'block !important' : 'none !important'
    }
  })
};